export default __webpack_public_path__ + "static/media/xicon.b0e39d6a.svg";